export default "__VITE_ASSET__sxyNl7uB__"